import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

import { HistogramGender } from 'src/components/HistogramGender';
import { getGenderHistogramTone } from 'src/data/demographics';
import { InsightBox } from '../InsightBox';
import { getGenderTitle } from '../Histograms';
import { Loader } from './components/Loader';
import { useStyles } from './useStyles';

export const HistogramGenderScore = ({ classes, data, loading }) => {
  const styles = useStyles({ classes });

  const genderTone = useMemo(() => getGenderHistogramTone(data || []), [data]);
  const genderTitle = getGenderTitle(genderTone);

  return (
    <InsightBox className={styles.root}>
      <Typography className={styles.title}>{genderTitle}</Typography>
      {loading ? (
        <Loader />
      ) : (
        <HistogramGender
          data={data}
          hideGrid
          margin={{ left: 0, right: 0 }}
          displayScoreTicks
        />
      )}
    </InsightBox>
  );
};

HistogramGenderScore.propTypes = {
  classes: PropTypes.shape(),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number,
    })
  ),
  loading: PropTypes.bool,
};

HistogramGenderScore.defaultProps = {
  classes: null,
  data: [],
  loading: false,
};
